// import { rem, rgba } from 'polished';
// import { css } from 'styled-components';

// const boxShadowMixin = (top, left, blur, color, inset = false) => {
//   return `box-shadow: ${inset ? 'inset' : ''} ${top}px ${left}px ${blur}px ${color};`;
//  }

// TODO: add the remainder of shadows.scss styles
const small = '0 2px 8px 0 rgba(0, 0, 0, 0.1)'
const medium = '0 4px 16px 0 rgba(0, 0, 0, 0.1)'
const large = '0 8px 32px 0 rgba(0, 0, 0, 0.3)'
const inner = 'inset 0px -6px 6px 0 rgba(0, 0, 0, 0.1)'

export default {
  small,
  medium,
  large,
  inner
}